
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/watch/[project]/livestreams",
      function () {
        return require("private-next-pages/[locale]/watch/[project]/livestreams/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/watch/[project]/livestreams"])
      });
    }
  